/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * 企业列表
     * @param _
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    async queryList(_, data) {
      return await api.post(`/api/enterprise/getEnterpriseLists`, data);
    },
    
    async queryProjectList(_, data) {
      return await api.post(`/api/enterprise/getProjectLists`, data);
    },
    /**
     * 企业详情
     * @param _
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    async queryDetail(_, data) {
      return await api.post(`/api/enterprise/getEnterpriseInfo`, data);
    },
  },
}
